import { Component, OnInit, ViewChild, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { NgForm, FormGroup, FormControl } from '@angular/forms';
import { Globals } from '../globals';
import { DoKycRequest, KycVerifyRes } from 'src/app/kyc-verify/kyc-verify.model';
import { ActivatedRoute, Params } from '@angular/router';
import { KycVerifyService } from 'src/app/kyc-verify/kyc-verify.service';

@Component({
  selector: 'app-kyc-verify',
  templateUrl: './kyc-verify.component.html',
  styleUrls: ['./kyc-verify.component.css']
})
export class KycVerifyComponent implements OnInit {

  @ViewChild('kycDetailsForm') kycDetailsForm: any;
  showValidationMsgs: boolean = false;
  isLoading: boolean = false;
  uniqueId: string;
  doKycRequest: DoKycRequest;
  kycVerifyRes: KycVerifyRes;
  isSuccess: boolean = false;
  errMsg: string;
  successMsg: string;
  redirectErrMsg: string;
  kycStatus: string = "Success";

  constructor(private route: ActivatedRoute, public globals: Globals, public kycVerifyService: KycVerifyService) {
    this.doKycRequest = new DoKycRequest();
    this.kycVerifyRes = new KycVerifyRes();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      (params: Params) => {
        this.uniqueId = params["id"];
        if(this.uniqueId != null && this.uniqueId != '' && this.uniqueId != undefined) {
          this.verifyKycDetails();
        }
      }
    );
  }

  verifyKycDetails() {
    this.isLoading = true;
    let body = {
      "uniqueId": this.uniqueId
    }
    this.kycVerifyService.verifyKycDetails(body).subscribe((data: any) => {
      this.isLoading = false;
      this.kycVerifyRes = JSON.parse(JSON.stringify(data));
      if(this.kycVerifyRes.errMsg != '' && this.kycVerifyRes.errMsg != null && this.kycVerifyRes.errMsg != undefined) {
        this.errMsg = this.kycVerifyRes.errMsg;
        this.redirectErrMsg = this.kycVerifyRes.errMsg;
      } else {
        if(this.kycVerifyRes.linkURL != '' && this.kycVerifyRes.linkURL != null && this.kycVerifyRes.linkURL != undefined) {
          this.redirectErrMsg = "Kyc Details Not Found";
          this.successMsg = "Kyc Details Not Found, Kyc link generated to do self verification, Please click back button to proceed...";
          this.kycStatus = "Failed";
        } else {
          if(this.kycVerifyRes.kycDetails.ckycNo != '' && this.kycVerifyRes.kycDetails.ckycNo != null && this.kycVerifyRes.kycDetails.ckycNo != undefined) {
            this.successMsg = "Kyc Details verified successfully, Please click back button to proceed...";
          }
        }
      } 
    });
  }

  GoToBackPage() {
    this.isLoading = true;
    var form = document.createElement("form");
    var element1 = document.createElement("input"); 
    var element2 = document.createElement("input");
    var element3 = document.createElement("input");
    var element4 = document.createElement("input");
    var element5 = document.createElement("input");
    var element6 = document.createElement("input");
    var element7 = document.createElement("input"); 
    var element8 = document.createElement("input");
    var element9 = document.createElement("input");
    var element10 = document.createElement("input");
    var element11 = document.createElement("input");
    var element12 = document.createElement("input");
    var element13 = document.createElement("input"); 
    var element14 = document.createElement("input");
    var element15 = document.createElement("input");
    var element16 = document.createElement("input");
    var element17 = document.createElement("input");
    var element18 = document.createElement("input");
    var element19 = document.createElement("input"); 
    var element20 = document.createElement("input");
    var element21 = document.createElement("input");
    var element22 = document.createElement("input");

    form.method = "POST";
    form.action = this.kycVerifyRes.returnURL;  

    element1.value = this.kycVerifyRes.linkURL;
    element1.name = "kycLink";
    form.appendChild(element1);  

    element2.value = this.kycVerifyRes.kycRefNo;
    element2.name = "kycRefNo";;
    form.appendChild(element2);

    element3.value = this.kycVerifyRes.kycDetails.firstName;
    element3.name = "firstName";;
    form.appendChild(element3);

    element4.value = this.kycVerifyRes.kycDetails.middleName;
    element4.name = "middleName";
    form.appendChild(element4);

    element5.value = this.kycVerifyRes.kycDetails.lastName;
    element5.name = "lastName";
    form.appendChild(element5);

    element6.value = this.kycVerifyRes.kycDetails.address1;
    element6.name = "address1";
    form.appendChild(element6);

    element7.value = this.kycVerifyRes.kycDetails.address2;
    element7.name = "address2";
    form.appendChild(element7);

    element8.value = this.kycVerifyRes.kycDetails.address3;
    element8.name = "address3";
    form.appendChild(element8);

    element9.value = this.kycVerifyRes.kycDetails.address4;
    element9.name = "address4";
    form.appendChild(element9);

    element10.value = this.kycVerifyRes.kycDetails.state;
    element10.name = "state";
    form.appendChild(element10);

    element11.value = this.kycVerifyRes.kycDetails.city;
    element11.name = "city";
    form.appendChild(element11);

    element12.value = this.kycVerifyRes.kycDetails.district;
    element12.name = "district";
    form.appendChild(element12);

    element13.value = this.kycVerifyRes.kycDetails.country;
    element13.name = "country";
    form.appendChild(element13);

    element14.value = this.kycVerifyRes.kycDetails.pinCode;
    element14.name = "pinCode";
    form.appendChild(element14);

    element15.value = this.kycVerifyRes.kycDetails.ckycNo;
    element15.name = "ckycNo";
    form.appendChild(element15);

    element16.value = this.kycVerifyRes.kycDetails.panNumber;
    element16.name = "panNumber";
    form.appendChild(element16);

    element17.value = this.kycVerifyRes.kycDetails.aadharNumber;
    element17.name = "aadharNumber";
    form.appendChild(element17);

    element18.value = this.kycVerifyRes.kycDetails.dateOfBirth;
    element18.name = "dateOfBirth";
    form.appendChild(element18);

    element19.value = this.kycVerifyRes.kycDetails.userName;
    element19.name = "userName";
    form.appendChild(element19);

    element20.value = this.kycStatus;
    element20.name = "kycStatus";
    form.appendChild(element20);

    element21.value = this.redirectErrMsg;
    element21.name = "errMsg";
    form.appendChild(element21);

    element22.value = "direct";
    element22.name = "from";
    form.appendChild(element22);

    document.body.appendChild(form);
    form.submit();
  }
}
